/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreatePrivacyPolicyRequest } from '../model/createPrivacyPolicyRequest';
import { ErrorResponse } from '../model/errorResponse';
import { PrivacyPolicyList } from '../model/privacyPolicyList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class PrivacyService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param countryCode 
     * @param createPrivacyPolicyRequest Order Request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addPrivacyPolicy(countryCode: string, createPrivacyPolicyRequest: CreatePrivacyPolicyRequest, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicyList>;
    public addPrivacyPolicy(countryCode: string, createPrivacyPolicyRequest: CreatePrivacyPolicyRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicyList>>;
    public addPrivacyPolicy(countryCode: string, createPrivacyPolicyRequest: CreatePrivacyPolicyRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicyList>>;
    public addPrivacyPolicy(countryCode: string, createPrivacyPolicyRequest: CreatePrivacyPolicyRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling addPrivacyPolicy.');
        }
        if (createPrivacyPolicyRequest === null || createPrivacyPolicyRequest === undefined) {
            throw new Error('Required parameter createPrivacyPolicyRequest was null or undefined when calling addPrivacyPolicy.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PrivacyPolicyList>(`${this.configuration.basePath}/privacy-policy/${encodeURIComponent(String(countryCode))}`,
            createPrivacyPolicyRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPrivacyPolicy(observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicyList>;
    public getPrivacyPolicy(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicyList>>;
    public getPrivacyPolicy(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicyList>>;
    public getPrivacyPolicy(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PrivacyPolicyList>(`${this.configuration.basePath}/privacy-policy`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
